export default __webpack_public_path__ + "static/media/DJI_0971.MP4.00_04_58_07.Still005.74d498f2.jpg";